import ApiService from '@/services/api.service'


const DaeService = {


/**
	 * Retourne un DAE d'une victime 
	 * @param {Number} victimId identifiant de la victime
	 * @param {Number} order numéro d'ordre du bilan
	 */
	getDae: async function(victimId, order) {
		const response = await ApiService.get('/api/daes/'+ victimId + '/' + order);
		return response.data
	}


}

export default DaeService